import {
  setCargoPreScreenData,
  setIplPreScreenData,
  setWcPreScreenData,
} from "src/jsonForms/jsonFormsSlice";

import CargoPreScreen from "./CargoPreScreen";
import IplPreScreen from "./IplPreScreen";
import WcPreScreen from "./WcPreScreen";
import type {
  CargoPreScreenData,
  IplPreScreenData,
  LobKey,
  PreScreenLobConfig,
  WcPreScreenData,
} from "./types";

const WC_LOB_CONFIG: PreScreenLobConfig<WcPreScreenData> = {
  lobKey: "wc",
  PreScreenComponent: WcPreScreen,
  buildSchemaName: ({ resolvedTpa }) => `WC-${resolvedTpa}-v1_0_0`,
  selectPreScreenData: (state) => state.jsonForms.preScreen.wc,
  saveAction: setWcPreScreenData,
};

const CARGO_LOB_CONFIG: PreScreenLobConfig<CargoPreScreenData> = {
  lobKey: "cargo",
  PreScreenComponent: CargoPreScreen,
  //Temporarily hardcoded cargo schema name
  buildSchemaName: () => `wkwebster-cargo-eu-middle-mile-register`,
  selectPreScreenData: (state) => state.jsonForms.preScreen.cargo,
  saveAction: setCargoPreScreenData,
};

const IPL_LOB_CONFIG: PreScreenLobConfig<IplPreScreenData> = {
  lobKey: "ipl",
  PreScreenComponent: IplPreScreen,
  buildSchemaName: ({ resolvedTpa }) => `IPL-${resolvedTpa}-v1_0_0`,
  selectPreScreenData: (state) => state.jsonForms.preScreen.ipl,
  saveAction: setIplPreScreenData,
};

/**
 * Discriminated union of every LOB's `PreScreenLobConfig`. The shell
 * narrows by `lobKey` before invoking `buildSchemaName` /
 * `selectPreScreenData` / `saveAction`, so each callback always sees
 * the matching `TData` shape without needing a cast.
 */
export type AnyPreScreenLobConfig =
  | PreScreenLobConfig<WcPreScreenData>
  | PreScreenLobConfig<CargoPreScreenData>
  | PreScreenLobConfig<IplPreScreenData>;

/**
 * The single LOB registry consumed by `JsonFormsClaimIntakeApp`. Adding
 * a new LOB requires one new entry here, one new pre-screen component,
 * and a new `LOB_ROLES` entry in `lobAccess.ts`.
 */
export const LOB_CONFIGS: Record<LobKey, AnyPreScreenLobConfig> = {
  wc: WC_LOB_CONFIG,
  cargo: CARGO_LOB_CONFIG,
  ipl: IPL_LOB_CONFIG,
};
